// extracted by mini-css-extract-plugin
export default {"divider":"styles_divider__8KQ+L","screenReader":"styles_screenReader__4sPx9"};